import { Injectable } from '@angular/core';

@Injectable()
export class SidekickService {

	public tokenParamName = 'tokenParam';
	public tokenParam: string;
	constructor() { }
	checkTokenParam() {
		const hash = window.location.hash ? decodeURIComponent(window.location.hash): '';
		// Reference: https://developers.arcgis.com/documentation/core-concepts/security-and-authentication/browser-based-user-logins/#using-the-arcgis-api-for-javascript
		const splits = hash.split('#');
		splits.find(s => {
			const reg = this.tokenParamName + '=([^&]+)';
			const matchParam = s.match(new RegExp(reg));
			if (matchParam && matchParam[1]) {
				this.tokenParam = matchParam[1];
				return true;
			}
		});
		// const socketParam = this.injector.get(ActivatedRoute) //.snapshot.paramMap.get(this.socketParamName);
		// if (socketParam) {
		// 	console.log('start sockettttttttttttttttttt');
		// } else {
		// 	console.log('noooooooooooooo')
		// }
	}
}
